import { FunctionComponent } from 'react';
import { getOrganisationUrl, JSONEditor } from '../../../../shared';

import classes from './OrgConfig.module.scss';

export const OrgConfig: FunctionComponent = () => {
  return (
    <div className={classes['config']}>
      <JSONEditor
        id={'org-config'}
        schemaUrl={`${getOrganisationUrl()}/v1/config/schema`}
        configUrl={`${getOrganisationUrl()}/v1/config`}
        className={classes['config--theme']}
      />
    </div>
  );
};
